import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  output,
} from '@angular/core';
import { HorizontalMenuItemComponent } from '../horizontal-menu-item/horizontal-menu-item.component';
import { HorizontalMenuService } from '@/layout/service/horizontal-menu.service';
import { OptionLink } from '@/layout/models/link';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'store-horizontal-menu-2',
  imports: [NgClass, HorizontalMenuItemComponent],
  templateUrl: './horizontal-menu.component.html',
  styleUrl: './horizontal-menu.component.css',
  providers: [HorizontalMenuService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalMenuComponent {
  #destroyRef = inject(DestroyRef);
  protected horMenuSrv = inject(HorizontalMenuService);
  readonly menuItems = input<OptionLink[]>([]);
  horizontalMenuContainerCssClass = input('horizontal-menu-container');
  horizontalMenuContentCssClass = input('horizontal-menu-content');
  menuItemCssClass = input('menu-item');

  optionLinkSelected = output<OptionLink>();

  constructor() {
    effect(() => {
      this.horMenuSrv.setItems(this.menuItems());
    });

    this.horMenuSrv.selectedItem
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(data => this.optionLinkSelected.emit(data));
  }
}
